import instanceAxios from "./intanceAxios";

export const classificationService = {
    getClassification: async (params) => await instanceAxios.get('/assets/classification/', { params }),
    createClassification: async (params) => await instanceAxios.post('/assets/classification/', params)
}